import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./channelBox.css";
import { IP } from "../../../../../internalServer";
import { useLocation } from "react-router-dom";
import assets from "../../../../../assets/assets";

const ChannelBox = ({
  communityData,
  postCreatedCount,
  setActive,
  postRequestCount,
  setViewFirstInProgress,
  selectedCommunity,
  requestPostCount,
}) => {
  const { state } = useLocation();

  return communityData ? (
    <div
      className="d-flex my-1 py-2  gap-2 mb-2 channel_name_box w-100 rounded-3 shadow-sm"
      style={{ backgroundColor: "white" }}
    >
      <img
        className="channel_icon mr-2"
        src={`${IP}${communityData?.profile_picture}`}
        alt=""
        onError={(e) => {
          e.target.src = assets.CommunityImg;
        }}
      />
      <div className="d-flex flex-column gap-1 mr-5 w-100">
        <NavLink
          to="/viewFirstScreen"
          className="link"
          state={{ communityId: communityData?.id }}
        >
          <span
            title={communityData?.community_name}
            onClick={() => {
              if (state?.communityId !== communityData?.id) {
                setViewFirstInProgress(false);
              }
              setActive("About");
              localStorage.setItem("TypeClicked", "About");
            }}
            className="poppins-semibold text-truncate d-inline-block"
            style={{ maxWidth: "250px", cursor: "pointer" }}
          >
            {communityData?.community_name}
          </span>
        </NavLink>
        <div
          className="d-flex flex-column w-100"
          style={{ fontSize: "0.75rem" }}
        >
          <div className="d-flex flex-row g justify-content-between align-items-center">
            <small className="text-muted">Created By:</small>
            <small className="">{communityData?.user_id?.name}</small>
          </div>
          <div className="d-flex flex-row justify-content-between align-items-center">
            <small className="text-muted">Total Post:</small>
            <small className="">
              {state?.communityId === communityData?.id
                ? communityData?.active_post_count +
                  postRequestCount +
                  postCreatedCount
                : selectedCommunity === communityData?.id
                ? communityData?.active_post_count + postCreatedCount
                : communityData?.active_post_count}
            </small>
          </div>
          <div className="d-flex flex-row  justify-content-between align-items-center">
            <small className="text-muted">Pending Post:</small>
            <small className="">{communityData?.request_post_count}</small>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default ChannelBox;
